// src/context/CartContext.jsx
import React, { createContext, useContext, useReducer, useEffect } from "react";

const CartContext = createContext(null);

const cartReducer = (state, action) => {
  switch (action.type) {
    case "ADD_ITEM": {
      const exists = state.items.find((i) => i.id === action.payload.id);
      if (exists) {
        return {
          ...state,
          items: state.items.map((i) =>
            i.id === action.payload.id ? { ...i, qty: i.qty + 1 } : i
          ),
        };
      }
      return { ...state, items: [...state.items, { ...action.payload, qty: 1 }] };
    }
    case "REMOVE_ITEM":
      return { ...state, items: state.items.filter((i) => i.id !== action.payload) };
    case "UPDATE_QTY":
      return {
        ...state,
        items: state.items.map((i) =>
          i.id === action.payload.id ? { ...i, qty: Math.max(1, action.payload.qty) } : i
        ),
      };
    case "CLEAR":
      return { ...state, items: [] };
    default:
      return state;
  }
};

const loadCart = () => {
  try { return JSON.parse(localStorage.getItem("agro_cart") || "[]"); }
  catch { return []; }
};

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, { items: loadCart() });

  useEffect(() => {
    localStorage.setItem("agro_cart", JSON.stringify(state.items));
  }, [state.items]);

  const addItem    = (product) => dispatch({ type: "ADD_ITEM",    payload: product });
  const removeItem = (id)      => dispatch({ type: "REMOVE_ITEM", payload: id });
  const updateQty  = (id, qty) => dispatch({ type: "UPDATE_QTY",  payload: { id, qty } });
  const clearCart  = ()        => dispatch({ type: "CLEAR" });

  const total    = state.items.reduce((s, i) => s + i.price * i.qty, 0);
  const count    = state.items.reduce((s, i) => s + i.qty, 0);
  const subtotal = total;

  return (
    <CartContext.Provider value={{ items: state.items, total, count, subtotal, addItem, removeItem, updateQty, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
};
